
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"20","viewBox":"0 0 128 128","width":"20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"64","cy":"64","fill":"RGBA(126, 198, 98, 1)","r":"64","data-name":"Circle Grid"}}),_c('path',{attrs:{"d":"M97.63 98.416v.062a4.6 4.6 0 01-6.024 4.3A91.743 91.743 0 0064 98.628a91.743 91.743 0 00-27.606 4.15 4.6 4.6 0 01-6.024-4.3v-.062c0-6.045 3.107-12.28 8.238-17.277a36.6 36.6 0 0150.782 0c5.132 4.997 8.24 11.232 8.24 17.277z","fill":"#62667c"}}),_c('path',{attrs:{"d":"M89.391 81.139a36.664 36.664 0 01-50.782 0 36.6 36.6 0 0150.782 0z","fill":"#4f5363"}}),_c('circle',{attrs:{"cx":"64","cy":"54.627","fill":"#eeefee","r":"33.627"}}),_c('path',{attrs:{"d":"M64 74.318a19.69 19.69 0 1119.691-19.69A19.713 19.713 0 0164 74.318z","fill":"#62667c"}}),_c('path',{attrs:{"d":"M64 69.156a14.528 14.528 0 1114.529-14.529A14.545 14.545 0 0164 69.156z","fill":"#828a9e"}}),_c('path',{attrs:{"d":"M64 63.994a9.367 9.367 0 119.367-9.366A9.377 9.377 0 0164 63.994z","fill":"#69b0ee"}}),_c('circle',{attrs:{"cx":"64","cy":"28.7","fill":"#ef5261","r":"2.839"}}),_c('ellipse',{attrs:{"cx":"59.926","cy":"51.086","fill":"#eeefee","rx":"4.065","ry":"2.065","transform":"rotate(-45 59.921 51.102)"}})])
          )
        }
      }
    